import React from 'react';
import {ImageBase, ImageBaseProps} from './ImageBase';
import {checkboxOrangeChecked} from 'utils';

export interface IImageCheckboxPressedProps extends ImageBaseProps {}

export function ImageCheckboxPressed({style}: IImageCheckboxPressedProps) {
  return <ImageBase source={checkboxOrangeChecked} style={style} />;
}
